<template>
  <div>
    <header id="header-container" class="fullwidth ">
      <!-- Header -->
      <div id="header">
        <div class="container">
          <!-- Left Side Content -->
          <div class="left-side">
            <!-- Logo -->
            <div id="logo">
              <router-link to="/"
                ><img
                  src="@/assets/images/company-logo-01.png"
                  alt="3hjobs.com"
                  class="logo"
              /></router-link>
            </div>

            <!-- Main Navigation -->
            <nav id="navigation">
              <ul id="responsive">
                <li v-if="isLoggedIn">
                  <router-link to="/dashboard" class="nav-item--align"
                    >My Dashboard</router-link
                  >
                </li>
                <li v-else>
                  <router-link class="current nav-item--align" to="/" tag="a"
                    >Home</router-link
                  >
                </li>

                <li>
                  <a href="#">Services</a>
                  <ul class="dropdown-nav">
                    <li v-for="service in services" :key="service.id">
                      <a href="#">{{ service.name }}</a>
                      <ul class="dropdown-nav">
                        <li
                          v-for="subTask in service.sub_tasks"
                          :key="subTask.id"
                        >
                          <a href="#">{{ subTask.name }}</a>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>

                <li v-for="(nav, index) in navMenus" :key="index">
                  <router-link :to="nav.to" class="nav-item--align">{{
                    nav.name
                  }}</router-link>
                </li>
              </ul>
            </nav>
            <div class="clearfix"></div>
            <!-- Main Navigation / End -->
          </div>
          <!-- Left Side Content / End -->

          <!-- Right Side Content / End -->
          <div class="right-side">
            <!--  User Notifications -->
            <div class="header-widget hide-on-mobile">
              <!-- Messages -->
              <div class="header-notifications">
                <div class="header-notifications-trigger">
                  <router-link
                    :to="isLoggedIn ? '/dashboard/messages' : '/login'"
                    ><i class="icon-feather-mail"></i
                    ><span>{{ isLoggedIn ? "3" : "" }}</span></router-link
                  >
                </div>
              </div>
            </div>

            <div class="header-widget">
              <div class="header-notifications user-menu">
                <div class="header-notifications-trigger">
                  <a v-if="isLoggedIn" title="logout" href="" @click="logout()"
                    ><i class="icon-material-outline-power-settings-new"></i
                  ></a>
                  <router-link v-else to="/login"
                    ><small>Login</small></router-link
                  >
                </div>
              </div>
            </div>

            <!-- Mobile Navigation Button -->
            <span class="mmenu-trigger">
              <button class="hamburger hamburger--collapse" type="button">
                <span class="hamburger-box">
                  <span class="hamburger-inner"></span>
                </span>
              </button>
            </span>
          </div>
          <!-- Right Side Content / End -->
        </div>
      </div>
      <!-- Header / End -->
    </header>
    <div class="clearfix"></div>
  </div>
</template>

<script>
/* eslint-disable no-console */
import { getCall } from "../../../core/services/http.service";
import { USER_NAV_BAR_MENUS } from "../../../plugins/config/constants";
import { removeToken } from "../../../plugins/handlers";
import { ALL_TASKS_AND_SUBTASKS } from "../../../core/config/endpoints/tasks";
import { LOGOUT } from "../../../core/config/endpoints/auth";
import router from "../../../router";

export default {
  name: "AppNavbar",
  data: function() {
    return {};
  },

  methods: {
    logout() {
      getCall(LOGOUT)
        .then(() => {})
        .finally(() => {
          removeToken();
          if (this.$route.name != "Home") return router.push("/");
        });
    },

    getAllTasks() {
      getCall(ALL_TASKS_AND_SUBTASKS)
        .then(response => {
          let payload = {
            key: "allTasksAndSubTasks",
            value: response.data.data,
          };
          this.$store.commit("commitItem", payload);
          // this.services = response.data.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
  },

  computed: {
    isLoggedIn() {
      return !!this.$store.state.token;
    },

    services() {
      return this.$store.state.allTasksAndSubTasks;
    },

    navMenus() {
      return USER_NAV_BAR_MENUS;
    },

    loggedInUser() {
      return this.$store.state.userData;
    },
  },

  mounted() {
    if (!this.services || !this.services.length) return this.getAllTasks();
  },
};
</script>

<style scoped>
.logo {
  width: 40px !important;
}
.nav-item--align {
  padding: 7px 9px !important;
}
.menuBug {
  width: 35px;
  height: 5px;
  background-color: black;
  margin: 6px 0;
}
</style>
